import { render } from "./TraderLogin.vue?vue&type=template&id=0dda18f1"
import script from "./TraderLogin.vue?vue&type=script&lang=js"
export * from "./TraderLogin.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__